import React, {Component} from 'react';
import { Col, Label, Input, FormGroup } from "reactstrap";
import { formataMoeda } from "../../../utils/functions";

import _ from 'lodash';

export default class FormInput extends Component {
    constructor(props) {
        super(props);

        let valor = this.props.defaultValue ? this.props.defaultValue : 0;

        if (this.props.formataMoeda && valor)
            valor = formataMoeda(this.props.defaultValue, this.props.prefixo, this.props.separadorMilesimo, this.props.separadorDecimal);

        this.state = {
            alerta: this.props.alerta,
            value: valor
        };
    }

    componentDidMount(){
        if (_.get(this.props.objeto, this.props.dado))
        {
            this.setState({
                value: _.get(this.props.objeto, this.props.dado)
            })
        }
        if (this.props.defaultValue)
        {
            let valor = this.props.defaultValue;

            if (this.props.formataMoeda && valor)
                valor = formataMoeda(this.props.defaultValue, this.props.prefixo, this.props.separadorMilesimo, this.props.separadorDecimal);

            this.setState({
                value: valor
            })
        }
    }

    componentDidUpdate(prevProps) {
        if(prevProps.alerta !== this.props.alerta) {
            this.setState({
                alerta: this.props.alerta
            });
        }        
    };

    handleChange = (event) => {
        this.props.onChange(event, event);
        let valor = event.target.value;

        if (this.props.formataMoeda)
            valor = formataMoeda(event.target.value, this.props.prefixo, this.props.separadorMilesimo, this.props.separadorDecimal);

        if(this.props.limiteMaximo){
            if(event.target.value.length <= this.props.limiteMaximo){
                this.setState({
                     value: valor
                })
            }
        }else{
            this.setState({
                value: valor
            })
        }        
    }

    handleBlur = (event) => {
        let invalido = (this.props.validador) ? this.props.validador(event.target.value) : false;
        let valor = event.target.value;
        
        if(invalido && this.props.validacaoStore){
            this.props.validacaoStore(false)
        }
        this.setState({
            alerta: invalido
        });

        // /^(?:\d{1,3}(?:,\d{3})+|\d+)(?:\.\d+)?$/g
        // /^([0-9]+(\,[0-9]{1,2})?)+([0-9]+(\.[0-9]{1,2})?)$

        if ( (/^([0-9]+(\,[0-9]{1,2})?)+([0-9]+(\.[0-9]{1,2})?)$/g).test(event.target.value))
        {
            //Caso seja necessario o formato de moeda
            if (this.props.formataMoeda)
                valor = formataMoeda(event.target.value, this.props.prefixo, this.props.separadorMilesimo, this.props.separadorDecimal);

            if(this.props.limiteMaximo){
                if(event.target.value.length <= this.props.limiteMaximo){                    
                    this.setState({
                        value: this.props.formataMoeda ? valor : event.target.value
                    })
                }
            }else{                
                this.setState({
                    value: this.props.formataMoeda ? valor : event.target.value
                })
            }
        }
        else if ((/^(?:\d+)(?:.\d+)?$/g).test(event.target.value))
        {
            //Caso seja necessario o formato de moeda
            if (this.props.formataMoeda)
                valor = formataMoeda(event.target.value, this.props.prefixo, this.props.separadorMilesimo, this.props.separadorDecimal);

            if(this.props.limiteMaximo){
                if(event.target.value.length <= this.props.limiteMaximo){
                    this.setState({
                        value: this.props.formataMoeda ? valor.toString() : event.target.value.toString().replace(".",",")
                    })
                }
            }else{                
                this.setState({
                    value: this.props.formataMoeda ? valor.toString() : event.target.value.toString().replace(".",",")
                })
            }
        }
        else 
        {
            invalido = true;
            if (this.props.validacaoStore){
                this.props.validacaoStore(false);
            }            
            this.setState({
                alerta: "Número inválido"
            })
        }

        if (!invalido) {
            this.salva(event);
            this.props.validacaoStore && this.props.validacaoStore(true)
        } 
    }
    
    salva = (event) => {
        this.props.onChange(event, event)
        if (this.props.onBlur) {
            this.props.onBlur(_.get(this.props.objeto, this.props.dado));
        }
    }

    render() {
        return(
            <Col className={`${this.props.className ? this.props.className : ""} ${this.props.col ? this.props.col : ""}`}
                xs={this.props.xs ? this.props.xs : 'auto'}
                sm={this.props.sm ? this.props.sm : 'auto'}
                md={!this.props.col && this.props.md ? this.props.md : 'auto'}>
                <FormGroup>
                    { this.props.titulo && <Label>{ this.props.titulo } { this.props.obrigatorio ? <span className="label-danger">*</span> : "" } </Label> }
                    <Input 
                        defaultValue={ this.state.value ? this.state.value : _.get(this.props.objeto, this.props.dado) }
                        value={this.state.value ? this.state.value : _.get(this.props.objeto, this.props.dado) }
                        className={ this.props.uppercase ? 'uppercase' : '' }
                        disabled = {this.props.bloqueado ? "disabled" : ""}
                        type="text"
                        min={ this.props.min ? this.props.min : 0 } max={ this.props.max ? this.props.max : 999999 }
                        onChange={ this.handleChange }
                        maxLength={this.props.limiteMaximo}
                        onBlur={ (event) => this.handleBlur(event, event) } />
                </FormGroup>
                { (this.props.labelStatus && this.props.labelStatus.length>0) ? <Label className="label-danger">{ this.props.labelStatus }</Label> : "" }
                { this.state.alerta
                    && <Col xs={12} className="col-label label-obrigatorio px-0">
                        <Label>{ this.state.alerta }</Label>
                    </Col>
                }
            </Col>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/comum/components/FormInputCurrency.js